export default {
	title: 'humidity_actions',
	components: [{ title: 'humidity_actions', component: 'humidity_actions' }],
};
